import axios from 'axios';
import axiosInterceptor from './axiosInterceptor';
import { environment } from './environment';

const wampServer = `${environment.SERVER_URL_FOR_IR_STRUCTURE}/api/`;
const axiosApiForIR = axios.create({
    baseURL: wampServer,
});

axiosInterceptor.setupInterceptors(axiosApiForIR, false, false);
export default axiosApiForIR;
